import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import Intro from '../components/home/intro';
import First from '../components/home/first';
import Interactivo from '../components/home/interactivo';
import Category from '../components/home/category';
import Presentation from '../components/home/presentation';
import { Link, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import Scrollspy from 'react-scrollspy'
import  buildLink  from '../funcs/buildlink';

export default class Index extends React.Component{
  state = {
    bg: '#5005f2',
    active: 'intro',
    results: false,
    showPresentation: true
  }

  componentDidMount(){
    var p = this.props.match.path;
    if(p.indexOf('interactivo') > -1){

      scroller.scrollTo('interactivo', {
        offset: -150
      });

    }

  }

  setCurrentSection(element){
    if(element){
      var id = element.getAttribute('id');
    }else{
      var id= false;
    }
    if(id){
      var color = '#4818c4';

      var dark = ['intro', 'interactivo'];

      switch(id){
        case "first":
          color = '#fbc402'
        break;
        case "interactivo":
          color = '#111';
        break;
        case "iresumen":
          color = '#111';
        break;
      }

      this.setState({
        // bg: color,
        active: id
      })

      // document.body.classList.remove('is-dark');
      // if(dark.indexOf(id) > -1){
      //   document.body.classList.add('is-dark');
      // }
    }
  }

  render(){
    return(
      <div id="home" style={{backgroundColor: this.state.bg}}>
        {
          this.state.showPresentation ?
            <Presentation onFinish={() => this.setState({showPresentation: false})}/>
          : null
        }
          <Intro active={this.state.active}/>
          <div id="icontent">
            <div id="icontent_container">

            <Element name="first">

              <First active={this.state.active}/>
            </Element>
            <Element name="interactivo">

              <Interactivo active={this.state.active} onFetch={(results) => this.setState({results: results})}/>
            </Element>
            </div>
          </div>
          {
            this.state.results ?
            <>
            <Category
              label={'laboral'}
              k={'laboral'}
              isDark
              or={this.state.results}
              r={this.state.results.p['laboral']}
              logo={require('../static/cat_2.png')}
              cover={require('../static/cat_cover_2.png')}
              bgs={['#e7c12d', '#f1f312']}
              colors={{
                highlight: [
                  'rgba(196, 26, 73, 0.87)',
                  'rgba(196, 26, 73, 0.83)'
                ],
                normal: [
                  'rgba(110, 110, 110, 0.5)',
                  'rgba(110, 110, 110, 0.1)'
                ],
                dark: '#666',
                clear: '#333'
              }}
            />

            <Category
              label={'familiar'}
              k={'familiar'}
              or={this.state.results}
              r={this.state.results.p['familiar']}
              logo={require('../static/cat_1.png')}
              cover={require('../static/cat_cover_1.png')}
              bgs={['#d30d81', '#ea7b63']}
              colors={{
                highlight: [
                  'rgba(240, 240, 240, 0.83)',
                  'rgba(240, 240, 240, 0.65)'
                ],
                normal: [
                  'rgba(255, 255, 3, 0.58)',
                  'rgba(255, 255, 3, 0.2)'
                ],
                clear: '#f0f0f0',
                dark: 'rgba(255, 255, 3, 1)'
              }}
            />


            <Category
              isDark
              label={'de consumidor'}
              k={'consumidor'}
              or={this.state.results}
              r={this.state.results.p['consumidor']}
              logo={require('../static/cat_4.png')}
              cover={require('../static/cat_cover_4.png')}
              bgs={['#06cb59', '#d7f305']}
              colors={{
                highlight: [
                  'rgba(252, 1, 71, 1)',
                  'rgba(128, 81, 241, 1)'
                ],
                normal: [
                  'rgba(240, 1, 67, 0.5)',
                  'rgba(240, 1, 67, 0.1)'
                ],
                dark: '#666',
                clear: '#333'
              }}
            />

            <Category
              label={'cívico'}
              k={'civico'}
              or={this.state.results}
              r={this.state.results.p['civico']}
              logo={require('../static/cat_3.png')}
              cover={require('../static/cat_cover_3.png')}
              bgs={['#440bee', '#483090']}
              colors={{
                highlight: [
                  'rgba(252, 1, 71, 1)',
                  'rgba(128, 81, 241, 1)'
                ],
                normal: [
                  'rgba(240, 1, 67, 0.5)',
                  'rgba(240, 1, 67, 0.1)'
                ],
                clear: '#f0f0f0',
                dark: '#999'
              }}
            />

          <div id="wjp_cta_page">
            <div id="wjp_cta_page_container">
              <div id="wjp_cta_page_container_t">Este interactivo fue desarrollado con datos del <a href="https://worldjusticeproject.mx/" target="_blank">World Justice Project</a></div>
              <div id="wjp_cta_page_container_bt">
                <a href="https://worldjusticeproject.mx/a2jmx-2019/" target="_blank">
                  Conoce la encuesta completa
                </a>
                <p>
                  Si deseas consultar la información completa del módulo de justicia cotidiana de la Encuesta a Población General en México, 2019 del WJP, que incluye más detalles acerca de los problemas de justicia cotidiana que enfrentan los encuestados, sus capacidades legales, sus fuentes de ayuda, sus reportes sobre el estado del problema, sus evaluaciones sobre el proceso de resolución y los posibles impactos que tuvieron en su vida, haz clic en el botón.
                </p>
                <a href={buildLink('/wjp.zip')} target="_blank">
                  Descarga los datos
                </a>
              </div>
            </div>
          </div>
            </>
          : null
          }
          <Scrollspy
            offset={-150}
            style={{display: 'none'}}
            items={ ['intro', 'first', 'interactivo', 'iresumen'] }
            currentClassName="is-current"
            onUpdate={(e) => this.setCurrentSection(e)}
          >
          </Scrollspy>
      </div>
    )
  }
}
